import styled from 'styled-components';

import { responsive, sp } from '@main/theme';

/**
 * Footer wrapper
 */
export const FooterWrapper = styled.div`
  ${responsive.beforeTablet} {
    padding: 0 0 ${sp(14)} 0;
    background-color: ${({ theme }) => theme.colors.bgAccent};
  }

  ${responsive.justTablet} {
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

/**
 * Padding around error page
 */
export const ErrorWrapper = styled.div`
  padding-top: 120px;
`;

/**
 * Wrap the entire page in a flex wrapper so that it can be set to always
 * fill the whole height.
 */
export const AppWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.sidebarNavBg};
`;
